import { Attributes, List, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";
import FreeTextEventMappingKeywordLookup from "./FreeTextEventMappingKeywordLookup";

@NeoModel
export default class FreeTextEventMappingLookup extends ModelBase {

    public rawGenericServiceProviderEventMappingId: number = 0;

    public serviceProviderGroupingName: string = "";

    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public destinationFieldId: number = 0;

    public destinationTableId: number = 0;

    public sourceFieldName: string = "";

    public rawGenericSourceTableName: string = "";
    
    @Rules.Required()
    @Attributes.Display("Value Includes")
    @Rules.StringLength(100)
    public rawSourceFieldIncludes: string = "";

    @Attributes.Display("Value Excludes")
    @Rules.StringLength(100)
    public rawSourceFieldExcludes: string | null = null;

    @Rules.Required()
    @Attributes.Display("Destination Event Type")
    @Rules.StringLength(100)
    public rawDestinationEventType: string = "";

    @Attributes.Display("Destination Corporate Action Type")
    @Rules.StringLength(100)
    public rawDestinationCorporateActionType: string | null = null;

    public isPositiveValueInd: boolean | null = null;

    public rawGenericServiceProviderEventKeywords = new List(FreeTextEventMappingKeywordLookup);

    public isExpanded: boolean | null = null;
}